// extracted by mini-css-extract-plugin
export default {"price":"P4-z","onSale":"Q4-z","msrpLabelPrice":"R4-z","msrpLabel":"S4-z","originalPrice":"T4-z","percentOff":"U4-z"};